var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { applyStyles, applyClass, any } from './utils';
import Drawer from './drawer';
var Navigation = /** @class */ (function (_super) {
    __extends(Navigation, _super);
    function Navigation(component, mezzanine) {
        var _this = _super.call(this, component, 'navigation') || this;
        _this.mezzanine = mezzanine;
        return _this;
    }
    Navigation.prototype.isHidden = function () {
        return this.component.navigationHide;
    };
    Navigation.prototype.isOpen = function () {
        return this.component.navigationOpen;
    };
    Navigation.prototype.getDrawerStyles = function (isMobile) {
        if (isMobile) {
            return {
                width: window.innerWidth,
                top: this.mezzanine.getVisibleHeaderHeight(),
                left: this.isOpen() ? 0 : -window.innerWidth
            };
        }
        return {
            width: this.component.navigationWidth,
            marginLeft: this.isOpen() ? 0 : -this.component.navigationWidth + this.getToggleDesktopWidth(isMobile)
        };
    };
    Navigation.prototype.update = function (isMobile) {
        return any([
            applyClass(this.drawer, 'awsui-app-layout--open', this.isOpen()),
            applyClass(this.drawer, 'awsui-app-layout__utils--hide', this.component.navigationHide),
            applyStyles(this.drawer, this.getDrawerStyles(isMobile))
        ]);
    };
    return Navigation;
}(Drawer));
export default Navigation;
//# sourceMappingURL=navigation.js.map